import * as React from 'react';
import * as Constants from 'src/constants';
import * as Layout from 'src/components/Layout';
import NavBar from 'src/views/Marketing/components/NavBar';
import Footer from 'src/views/Marketing/components/Footer';
import Link from 'next/link';
import { ScrollView, StyleSheet, Text, View } from 'react-native';

interface PropsIface {
  inApp?: boolean;
}

const Screen: React.FC<PropsIface> = (props) => {
  return (
    <>
      <ScrollView style={styles.scrollView}>
        {!Boolean(props.inApp) ? <NavBar /> : null}
        <Layout.EdgeGutter style={styles.contentContainerStyle}>
          <View style={Constants.GridStyle.MB4Unit}>
            <Text style={[Constants.TextStyle.T42B, Constants.TextStyle.ACenter]}>
              {'Want to chat? Reach out at any time.'}
            </Text>
            <Text style={[Constants.TextStyle.T24R, Constants.TextStyle.CDarkGray, Constants.TextStyle.ACenter]}>
              {'We’re available 18 hours a day, 7 days a week.'}
            </Text>
          </View>
          <View style={styles.contactMethodRow}>
            <View style={[styles.contactMethodColumn, Constants.GridStyle.MB4Unit]}>
              <Text style={Constants.TextStyle.T24B}>{'Email'}</Text>
              <Link href='mailto:support@oneshop.com'>
                <a
                  style={{
                    textDecoration: 'none',
                  }}
                >
                  <Text style={[Constants.TextStyle.T16R, Constants.TextStyle.CBolt]}>{'support@oneshop.com'}</Text>
                </a>
              </Link>
            </View>
            <View style={[styles.contactMethodColumn, Constants.GridStyle.MB4Unit]}>
              <Text style={Constants.TextStyle.T24B}>{'Text'}</Text>
              <Link href='sms:4158516800'>
                <a
                  style={{
                    textDecoration: 'none',
                  }}
                >
                  <Text style={[Constants.TextStyle.T16R, Constants.TextStyle.CBolt]}>{'(415) 851-6800'}</Text>
                </a>
              </Link>
            </View>
            <View style={[styles.contactMethodColumn, Constants.GridStyle.MB4Unit]}>
              <Text style={Constants.TextStyle.T24B}>{'Message'}</Text>
              <Link href='https://m.me/oneshopcompany'>
                <a
                  style={{
                    textDecoration: 'none',
                  }}
                  target='_blank'
                >
                  <Text style={[Constants.TextStyle.T16R, Constants.TextStyle.CBolt]}>{'On Facebook'}</Text>
                </a>
              </Link>
            </View>
            <View style={[styles.contactMethodColumn, Constants.GridStyle.MB4Unit]}>
              <Text style={[Constants.TextStyle.T24B, Constants.TextStyle.ACenter]}>
                {'Want to give feedback about our support?'}
              </Text>
              <Link href='mailto:support@oneshop.com'>
                <a
                  style={{
                    textDecoration: 'none',
                  }}
                >
                  <Text style={[Constants.TextStyle.T16R, Constants.TextStyle.CBolt]}>
                    {'support-feedback@oneshop.com'}
                  </Text>
                </a>
              </Link>
            </View>
            <View style={[styles.contactMethodColumn, Constants.GridStyle.MB4Unit]}>
              <Text style={Constants.TextStyle.T24B}>{'Business Banking Support'}</Text>
              <Text style={Constants.TextStyle.T16R}>{'This is for the OneShop Business Banking account only'}</Text>
              <Link href='mailto:banking-support@oneshop.com'>
                <a
                  style={{
                    textDecoration: 'none',
                  }}
                >
                  <Text style={[Constants.TextStyle.T16R, Constants.TextStyle.CBolt]}>
                    {'banking-support@oneshop.com'}
                  </Text>
                </a>
              </Link>
            </View>
          </View>
        </Layout.EdgeGutter>
        {!Boolean(props.inApp) ? <Footer /> : null}
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    paddingTop: 6 * Constants.Grid.dp(12),
  },
  contactMethodRow: {
    alignItems: 'center',
  },
  contactMethodColumn: {
    maxWidth: Constants.Grid.dp(480),
    alignItems: 'center',
  },
});

export default Screen;
